import React from "react";
import s from "../checklists.less";
import { useTranslation } from "react-i18next";
import ActionPlanCard from "./ActionPlanCard";
import { dateUTC } from "../helper";

const ActionPlan = (checklists) => {
  const { t } = useTranslation();
  const {
    inWorkTasks,
    completedTasks,
    overdueTasks,
    createdAt,
    checklistId,
    id,
    actionPlanDate,
    actionPlanId,
  } = checklists?.checklists?.[0] || {};

  return (
    <>
      <div className={s.planDate}>
        {t(`action_plan.from`)} {dateUTC(actionPlanDate)}
      </div>
      <div className={s.planCards}>
        <ActionPlanCard
          title="Cсылка в DNM "
          href={`https://vaz.autocrm.ru/action-plans?id=${actionPlanId}`}
          className={s.inProgress}
        />
        <ActionPlanCard
          title="В работе"
          count={inWorkTasks}
          className={s.inProgress}
        />
        <ActionPlanCard
          title="Завершено"
          count={completedTasks}
          className={s.completed}
        />
        <ActionPlanCard
          title="Просрочено"
          count={overdueTasks}
          className={s.overdue}
        />
      </div>
    </>
  );
};

export default ActionPlan;
